<template>
    <div>
        <v-layout>
            <v-switch v-model="form.idc_hc" hide-details label="Housses complexé (dans la limite de 2) :" class="title mt-0"
                @change="handleHousseComplexeChange" />
            <v-radio-group v-show="form.idc_hc" v-model="form.cover_type" class="mt-2 ml-8" hide-details row
                :disabled="!form.idc_hc">
                <v-radio class="mt-0" label="Pression" value="PRESSURE" />
                <v-radio class="mt-0" label="Crochet" value="HOOK" />
            </v-radio-group>
        </v-layout>

        <div v-show="form.idc_hc">
            <v-simple-table class="mb-3 mt-2">
                <thead>
                    <tr>
                        <th class="text-center" />
                        <th v-for="n in 6" :key="`h${n}`" class="text-center">
                            H{{ n }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>INTER</th>
                        <td v-for="n in 6" :key="`intern-h${n}`" class="mt-0 pt-0">
                            <div class="flex flex-col mb-4">
                                <v-select v-model="form[`hc_h${n}_interne_tissu`]" :items="colorsType" item-text="label"
                                    item-value="type" placeholder="Tissu" label clearable hide-details
                                    :disabled="!form.idc_hc" @change="() => handleTissuChange(n, 'interne')" />
                                <v-select v-model="form[`hc_h${n}_interne`]"
                                    :items="getAvailableColors(`hc_h${n}_interne_tissu`)" item-text="label"
                                    item-value="label" placeholder="Couleur" label clearable hide-details
                                    :disabled="!form.idc_hc || !form[`hc_h${n}_interne_tissu`]" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>EXTER</th>
                        <td v-for="n in 6" :key="`extern-h${n}`" class="mt-0 pt-0">
                            <div class="flex flex-col mb-4">
                                <v-select v-model="form[`hc_h${n}_externe_tissu`]" :items="colorsType" item-text="label"
                                    item-value="type" placeholder="Tissu" label clearable hide-details
                                    :disabled="!form.idc_hc" @change="() => handleTissuChange(n, 'externe')" />
                                <v-select v-model="form[`hc_h${n}_externe`]"
                                    :items="getAvailableColors(`hc_h${n}_externe_tissu`)" item-text="label"
                                    item-value="label" placeholder="Couleur" label clearable hide-details
                                    :disabled="!form.idc_hc || !form[`hc_h${n}_externe_tissu`]" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        form: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            colorsType: [
                { type: 'STRETCH', label: 'Stretch' },
                { type: 'ALCANTARA', label: 'Alcantara' },
                { type: '3D', label: '3D' }
            ]
        }
    },

    methods: {
        handleHousseComplexeChange(value) {
            if (!value) {
                this.clearHousseComplexe();
            }
        },

        clearHousseComplexe() {
            // Réinitialiser le type de couverture
            this.$set(this.form, 'cover_type', null);

            // Réinitialiser tous les champs de housse
            this.formKeys.forEach(key => {
                if (this.form.hasOwnProperty(key)) {
                    this.$set(this.form, key, null);
                }
            });
        },

        getAvailableColors(tissuFieldName) {
            const selectedType = this.form[tissuFieldName];
            return selectedType ? this.getColorsByType(selectedType) : [];
        },

        handleTissuChange(position, type) {
            // Réinitialise la couleur correspondante quand le type de tissu change
            const fieldName = `hc_h${position}_${type}`;
            this.$set(this.form, fieldName, null);
        },
    },

    computed: {
        ...mapGetters({
            getColorsByType: "colors/getColorsByType",
            colorById: 'colors/getColorById',
        }),

        formKeys() {
            const keys = [];
            for (let i = 1; i <= 6; i++) {
                keys.push(
                    `hc_h${i}_interne_tissu`,
                    `hc_h${i}_interne`,
                    `hc_h${i}_externe_tissu`,
                    `hc_h${i}_externe`
                );
            }
            return keys;
        },
    }
}
</script>